import { BoxProps, ColorOptions } from '@jfs/ui-new/'
import { ViewStyle } from 'react-native'

const defaultStyles = {
  underlayColor: 'SHADOW_GREY' as ColorOptions,
  modalContainer: {
    flex: 1,
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'SHADOW_GREY',
    zIndex: 1,
  } as BoxProps,
  container: {
    paddingTop: 4,
    borderRadius: 4,
    backgroundColor: 'WHITE',
  } as BoxProps,
  scrollView: {
    minHeight: 200,
  } as ViewStyle | BoxProps,
}

export const styles = {
  Default: {
    ...defaultStyles,
  },
  Alert: {
    ...defaultStyles,
    container: {
      borderRadius: 4,
      backgroundColor: 'WHITE',
      marginHorizontal: 8,
    } as BoxProps,
    scrollView: {} as ViewStyle | BoxProps,
  },
  Error: {
    ...defaultStyles,
    underlayColor: 'SHADOW_GREY' as ColorOptions,
    modalContainer: {
      ...defaultStyles.modalContainer,
      backgroundColor: 'VISIBLE_WHITE',
    } as BoxProps,
    container: {
      borderRadius: 4,
      marginHorizontal: 8,
    } as BoxProps,
    scrollView: {} as ViewStyle | BoxProps,
  },
  ErrorTop: {
    ...defaultStyles,
    underlayColor: 'SHADOW_GREY' as ColorOptions,
    modalContainer: {
      ...defaultStyles.modalContainer,
      backgroundColor: 'VISIBLE_WHITE',
      justifyContent: 'flex-start',
      bottom: 0,
      minHeight: '100vh',
      width: '100vw',
    } as BoxProps,
    container: {
      borderRadius: 4,
      marginHorizontal: 8,
    } as BoxProps,
    scrollView: { top: 20 } as ViewStyle | BoxProps,
  },
  Loader: {
    ...defaultStyles,
    underlayColor: 'transparent',
    modalContainer: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'TRANSPARENT',
      zIndex: 1,
    } as BoxProps,
    container: {
      borderRadius: 4,
      backgroundColor: 'TRANSPARENT',
    } as BoxProps,
    scrollView: {} as ViewStyle | BoxProps,
  },
  SELECTOR: {
    ...defaultStyles,
    underlayColor: 'transparent',
    modalContainer: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: 'TRANSPARENT',
      zIndex: 1,
    } as BoxProps,
    container: {
      borderRadius: 4,
      backgroundColor: 'TRANSPARENT',
    } as BoxProps,
    scrollView: {
      minWidth: 300,
      height: '100vh',
    } as ViewStyle | BoxProps,
  },
  NOTIFICATION: {
    ...defaultStyles,
    underlayColor: 'transparent',
    modalContainer: {
      flex: 1,
      position: 'absolute',
      top: 0,
      right: 0,
      height: '100%',
      width: '100%',
      alignItems: 'flex-end',
      backgroundColor: 'TRANSPARENT',

      zIndex: 1,
    } as BoxProps,
    container: {
      backgroundColor: 'TRANSPARENT',
    } as BoxProps,
    scrollView: {} as ViewStyle | BoxProps,
  },
  ALL_NOTIFICATIONS: {
    ...defaultStyles,
    underlayColor: 'transparent',
    modalContainer: {
      flex: 1,
      position: 'absolute',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: 'TRANSPARENT',
      zIndex: 1,
    } as BoxProps,
    container: { backgroundColor: 'TRANSPARENT' } as BoxProps,
    scrollView: {} as ViewStyle | BoxProps,
  },
  TRX_DETAILS: {
    underlayColor: 'transparent',
    modalContainer: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: 'SHADOW_LIGHT_GREY',
      zIndex: 1,
    } as BoxProps,
    container: {
      backgroundColor: 'WHITE',
      zIndex: 10,
    } as BoxProps,
    scrollView: {
      position: 'absolute',
      height: '100vh',
      right: 0,
      top: 0,
      flex: 1,
      shadowOffset: { width: 1, height: 1 },
      shadowRadius: 3,
      shadowColor: '#0000001F',
      borderRadius: 8,
      borderWidth: 1,
      borderColor: '#00000014',
      zIndex: 10,
    } as ViewStyle | BoxProps,
  },
  ADMIN_PORTAL_DIALOG: {
    underlayColor: 'transparent',

    modalContainer: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: 'SHADOW_LIGHT_GREY',
      zIndex: 1,
    } as BoxProps,
    container: {
      backgroundColor: 'WHITE',
      zIndex: 10,
    } as BoxProps,
    scrollView: {
      position: 'absolute',
      height: '100vh',
      right: 0,
      top: 0,
      flex: 1,
      shadowOffset: { width: 1, height: 1 },
      shadowRadius: 3,
      shadowColor: '#0000001F',
      borderRadius: 8,
      borderWidth: 1,
      borderColor: '#00000014',
      zIndex: 10,
    } as ViewStyle | BoxProps,
  },
  NAVBAR: {
    underlayColor: 'transparent',

    modalContainer: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      backgroundColor: 'SHADOW_LIGHT_GREY',

      zIndex: 1,
    } as BoxProps,
    container: {
      backgroundColor: 'WHITE',
    } as BoxProps,
    scrollView: {
      position: 'absolute',
      height: '100vh',
      left: 0,
      top: 0,
      bottom: 0,
    } as ViewStyle | BoxProps,
  },
  NAVBAR_RIGHT: {
    underlayColor: 'transparent',
    modalContainer: {
      flex: 1,
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      zIndex: 1,
      backgroundColor: 'MODAL_BG',
    } as BoxProps,
    container: {
      backgroundColor: 'WHITE',
    } as BoxProps,
    scrollView: {
      position: 'absolute',
      height: '100vh',
      right: 0,
      top: 0,
      bottom: 0,
    } as ViewStyle | BoxProps,
  },
  MODAL_BOTTOM: {
    underlayColor: 'transparent',

    modalContainer: {
      flex: 1,
      position: 'absolute',
      height: '100%',
      width: '100%',
      bottom: 0,
      backgroundColor: 'SHADOW_LIGHT_GREY',

      zIndex: 1,
    } as BoxProps,
    container: {
      backgroundColor: 'WHITE',
      position: 'absolute',
      width: '100vw',
      bottom: 0,
      minHeight: 50,
    } as BoxProps,
    scrollView: {
      position: 'absolute',
      right: 0,
      left: 0,
      bottom: 0,
    } as ViewStyle | BoxProps,
  },
}
